import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

interface GotoOption {
  replace?: boolean;
  render?: 'CSR' | 'SSR';
  containLanguagePrefix?: boolean;
}

const defaultOption: GotoOption = {
  replace: false,
  render: 'CSR',
  containLanguagePrefix: true,
};

const useGoto = () => {
  const history = useHistory();
  const { i18n: { language } } = useTranslation();

  const goto = useCallback((path: string, options?: GotoOption) => () => {
    options = {
      ...defaultOption, ...options,
    };
    const isReplace = !!options.replace;
    const isCSR = options.render === 'CSR';
    const targetPath = options.containLanguagePrefix ? `/${language}${path}` : path;

    if (isReplace && isCSR) {
      history.replace(targetPath);
    }
    if (isReplace && !isCSR) {
      window.location.replace(targetPath);
    }
    if (!isReplace && isCSR) {
      history.push(targetPath);
    }
    if (!isReplace && !isCSR) {
      window.location.assign(targetPath);
    }
  }, [history, language]);

  return goto;
};

export default useGoto;
